import { useGameSelector } from '../../GameStore';

import { DimensionsType, OriginType } from './slice';

export const useMWGameGridSlice = {
  getDimension: (dimension: DimensionsType): number | null => {
    return useGameSelector((state) => state.mwGameGrid.dimensions[dimension]);
  },
  getStreamOrigin: (): OriginType => {
    return useGameSelector((state) => state.mwGameGrid.origins.streamOrigin);
  },
  getHoverActiveNumber: (): number => {
    return useGameSelector((state) => state.mwGameGrid.hoverActiveNumber);
  },
};
